import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/quickbooks')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/dashboard/settings/accounting',
      search,
    });
  },
});
